// JavaScript для burger-menu
import { onReady } from '../base/init.js';

onReady(function () {
  // Код для burger-menu
});
